/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect } from 'react';
import { Stack, TableCell, TableRow, Typography } from '@mui/material';
import { formatDate } from '@/utils/constants';

export const InsightClaimRow = ({ claim }) => {
	return (
		<TableRow>
			<TableCell>
				<Stack direction='column'>
					<Typography sx={{ whiteSpace: 'nowrap' }}>{claim.PolicyNumber}</Typography>
					<Typography sx={{ whiteSpace: 'nowrap' }}>{claim.SubjectOfLoss}</Typography>
				</Stack>
			</TableCell>
			<TableCell size='small' align='left'>
				<Typography sx={{ whiteSpace: 'nowrap' }}>{formatDate(claim.LossDate)}</Typography>
			</TableCell>
			<TableCell>
				<Typography sx={{ minWidth: 125 }}>
					{claim.Description ?? claim.PolicyDescription}
				</Typography>
			</TableCell>
			<TableCell sx={{ minWidth: 250 }} align='left'>
				<Typography>{claim.InsurerName}</Typography>
			</TableCell>
		</TableRow>
	);
};
